import { Component } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { CruisebiosService } from 'src/app/Services/cruisebios.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type bioInfo = {
  crwName: string;
  crewRole: string;
  crbBioText: string;
  crbBioImageLink: string;
  spcPhoneNumber: string;
  crlOBPortalPhoneDisp: boolean;
  expander: boolean;
};

@Component({
  selector: 'app-contact-expander',
  templateUrl: './contact-expander.component.html',
  styleUrls: ['./contact-expander.component.css'],
  providers: [CruisebiosService],
})
export class ContactExpanderComponent {
  userdata?: UserData;
  evtcode: string | undefined;
  OBPortalSvcURL = '';
  imagepath = '';

  cruisebios: bioInfo[] | undefined;
  cruisebiodata: any;

  constructor(
    private appConfigService: AppConfigService,
    private CruisebiosService: CruisebiosService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.imagepath = this.appConfigService.imagepath;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.evtcode = cruiseContentEvtCodeFromSession(this.userdata);

    this.getCruiseBios();
  }
  getCruiseBios() {
    this.cruisebiodata = this.CruisebiosService.getCruiseBios(
      this.evtcode
    ).subscribe((cruisebiodata) => this.setCruiseBios(cruisebiodata));
  }

  setCruiseBios(resdata: any) {
    this.cruisebiodata = resdata;
    if (this.cruisebiodata.GetCruiseBios.Result.Status == 'A') {
      this.cruisebios = this.cruisebiodata.GetCruiseBios.CruiseBiosList;
    }
  }
}
